import axios from 'axios'
import { getToken, removeToken, setToken } from '@/utils/Auth'
import { API_URL } from '@/utils/Global'
import router from '@/router'
import store from '@/store'
const qs = require('qs')

class BaseModule{
  constructor (){
    this.$http = axios.create({
      baseURL: API_URL
    })
    this.$http.interceptors.request.use(
      config => {
        if (getToken()) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
          config.headers.Authorization = getToken()
        }
        return config
      },
      err => {
        return Promise.reject(err)
      }
    )
    this.$http.interceptors.response.use(
      response => {
        if(response.data.code === 401){
          removeToken()
          store.commit('SET_PERMISSION', [])
          router.replace({
            path: '/login'
          })
        }
        let token = getToken()
        if (response.data.token && token !== response.data.token && response.data.code === true) {
          setToken(response.data.token)
        }
        return response;
      },
      error => {
        return Promise.reject(error)
    });
    this.dataMethodDefaults = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      transformRequest: [function (data) {
        return qs.stringify(data, {
          arrayFormat: 'indices'
        })
      }]
    }
  }

  get(url, config = {}) {
    return this.$http.get(url, config)
  }

  post(url, data = undefined, config = {}) {
    return this.$http.post(url, data, { ...this.dataMethodDefaults, ...config })
  }

  put(url, data = undefined, config = {}) {
    return this.$http.put(url, data, { ...this.dataMethodDefaults, ...config })
  }

  delete(url, config = {}) {
    return this.$http.delete(url, config)
  }

}

export default BaseModule



// WEBPACK FOOTER //
// ./src/api/BaseModule.js